import { slack } from './slack';
import { googleOptimize } from './google-optimize';
import { googleAnalytics } from './google-analytics';
import { optimizely } from './optimizely';
import { zapier } from './zapier';
import { hubspot } from './hubspot';
import { msTeams } from './ms-teams';
import { mixpanel } from './mixpanel';
import { segment } from './segment';
import { omniconvert } from './omniconvert';
import { unbounce } from './unbounce';
import { webhooks } from './webhooks';

export const inHouseIntegrations = [
  slack,
  googleOptimize,
  optimizely,
  googleAnalytics,
  zapier,
  hubspot,
  msTeams,
  mixpanel,
  unbounce,
  webhooks,
];

export const externalIntegrations = [segment, omniconvert];
